var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService, { getXSRF } from "./Shared/FetchService";
import SingleResponseService from "../Domain/SingleResponse/SingleResponse.service";
const BASE_URL = "/aviso/attachment";
export default class AttachmentService {
    /**
     * Upload the files to Aviso's servers.
     *
     * @param {File[]} attachments - the file objects
     * @param {string} draftId - a unique identifier for the attachments.  Used so they can be deleted, referenced as a group later.
     * @returns {Promise<Attachment[]>} - attachment objects of the saved attachments
     */
    static uploadFiles(attachments, draftId) {
        return __awaiter(this, void 0, void 0, function* () {
            // https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch#Uploading_a_file
            const formData = new FormData();
            attachments.forEach((attachment, index) => formData.append("file" + index, attachment));
            // Not sure why we stringify this as JSON and then parse that on the server side, but this is how the angularJS
            // code is written.  Not changing that for now.
            formData.append("draftId", JSON.stringify({ draftId }));
            // Need to use fetch instead of the fetch service because content-headers needs to be undefined (not json).
            const response = yield fetch(BASE_URL + "/saveFiles", {
                credentials: "include",
                method: "POST",
                headers: {
                    "X-XSRF-TOKEN": getXSRF(),
                },
                body: formData,
            });
            const data = yield response.json();
            if (!response.ok) {
                throw data;
            }
            return SingleResponseService.processSingleResponse(data);
        });
    }
    static findAllByIds(ids) {
        return FetchService.getSingleResponse(BASE_URL + "/findById", { ids });
    }
    /**
     * Remove all files for the draft on the server.
     *
     * @param {string} draftId - unique identifier for the draft.
     * @returns {Promise<null>} resolution of the promise indicates the files were successfully deleted
     */
    static removeDirectory(draftId) {
        return FetchService.postSingleResponse(BASE_URL + "/removeDirectory", {
            body: { draftId },
        });
    }
    /**
     * Remove a particular attachment from the server
     *
     * @param {string} attachmentId - id of the attachment
     * @param {string} draftId - unique identifier for the draft.
     * @returns {Promise<null>} resolution of the promise indicates the files were successfully deleted
     */
    static removeAttachment(attachmentId, draftId) {
        return FetchService.postSingleResponse(BASE_URL + "/removeFile", {
            body: {
                attachmentId,
                draftId,
            },
        });
    }
    static canSendAttachmentsInline() {
        return FetchService.getSingleResponse(BASE_URL + "/canSendAttachmentsInline");
    }
}
